import { render, staticRenderFns } from "./input-wrapper.vue?vue&type=template&id=15688f6d&scoped=true&"
import script from "./input-wrapper.vue?vue&type=script&lang=ts&"
export * from "./input-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./input-wrapper.vue?vue&type=style&index=0&id=15688f6d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15688f6d",
  null
  
)

export default component.exports